//Livewire & AlpineJS
import { Livewire, Alpine } from '../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'
Alpine.plugin(Clipboard)

// Alpine.data here...

Livewire.start()

// Core version + navigation, pagination modules
import Swiper from 'swiper';
import { Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, FreeMode, Controller, EffectFade, EffectCube, EffectCreative, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cube';
import 'swiper/css/effect-flip';
import 'swiper/css/effect-cards';
import 'swiper/css/grid';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';
// Initialize Swiper modules
Swiper.use([Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, FreeMode,Controller,EffectFade, EffectCube, EffectCreative,Mousewheel]);

// Export for global use if needed
window.Swiper = Swiper

// PURE COUNTER
import PureCounter from "@srexi/purecounterjs";
window.PureCounter = PureCounter

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Lazy load
import lazySizes from 'lazysizes';

// FS Light Box
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Run App
const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();
    Fancybox.bind("[data-fancybox]", {});

    const productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    const productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    const productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });
};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})
